"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = truncate;
exports.toDOSLineEndings = toDOSLineEndings;
exports.capitalize = capitalize;
exports.pathToPascalCase = pathToPascalCase;
exports.escapeXML = escapeXML;
function truncate(str, len) {
    return str.length > len ? str.slice(0, len) + "…" : str;
}
function toDOSLineEndings(val) {
    return val.replace(/\n/g, "\r\n");
}
function capitalize(str) {
    return str
        .split(" ")
        .map((s) => { var _a; return `${((_a = s[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || ""}${s.slice(1)}`; })
        .join(" ");
}
function pathToPascalCase(path) {
    return path
        .split("/")
        .filter(Boolean) // remove empty strings from consecutive '/'
        .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
        .join("");
}
function escapeXML(str) {
    return str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
}
//# sourceMappingURL=string.util.js.map